import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "../api";

function useNoIndex() {
  useEffect(() => {
    const m = document.createElement("meta");
    m.name = "robots";
    m.content = "noindex, nofollow";
    document.head.appendChild(m);
    return () => { document.head.removeChild(m); };
  }, []);
}

export default function AdminLogin() {
  useNoIndex();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { username, pin });
      localStorage.setItem("checkin_admin_token", data.access_token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={submit} data-testid="admin-login-form">
        <img src="/checkin-tarife-logo.png" alt="Check'in Tarife" />
        <h1>Orientierungswerte</h1>
        <p>Geschützter Bereich. Bitte anmelden.</p>
        <label>Benutzername
          <input type="text" inputMode="numeric" autoComplete="off" value={username}
            onChange={(e) => setUsername(e.target.value)} data-testid="login-username" required />
        </label>
        <label>PIN
          <input type="password" inputMode="numeric" autoComplete="off" value={pin}
            onChange={(e) => setPin(e.target.value)} data-testid="login-pin" required />
        </label>
        {error && <div className="form-message" data-testid="login-error">{error}</div>}
        <button className="button button-coral button-full" type="submit" disabled={loading} data-testid="login-submit">
          {loading ? "Anmelden…" : "Anmelden"}
        </button>
        <a className="footer-link" href="/" style={{ color: "var(--muted)", textAlign: "center" }}>← Zur Website</a>
      </form>
    </div>
  );
}
